// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__rzWqP","footer":"ReportModalFilter_footer__3gerC"};